import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { createPortal } from "react-dom"
import { useGlobalContext } from "../data/GlobalContext"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import Deposit from "../transactions/Deposit"
import ModulesPeraBayong from "./promotion_modules/modules_peraBayong"
import LoginGlobal from "../data/LoginGlobal"
import useAppPromotionTheme from "../hooks/useAppPromotionTheme"

export default function PeraOBayong({ isLightMode }) {
  const data = promotionsData.find((promo) => promo.title === "Pera O Bayong")
  const { showMysteryFridayBtn } = useGlobalContext()
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [activeModal, setActiveModal] = useState(null)
  const [isDepositOpen, setIsDepositOpen] = useState(false)
  const isAppPromo = useAppPromotionTheme(isLightMode)

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    if (!isDepositOpen) return
    const prev = document.body.style.overflow
    document.body.style.overflow = "hidden"
    return () => {
      document.body.style.overflow = prev
    }
  }, [isDepositOpen])

  const modalComponents = {
    "Pera O Bayong": ModulesPeraBayong,
  }
  const ActiveModal = activeModal ? modalComponents[activeModal] : null

  return (
    <>
      {ActiveModal && <ActiveModal closeModal={() => setActiveModal(null)} />}
      <Helmet>
        <meta charSet="utf-8" />
        <title>Pera O Bayong</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a
                href={
                  isAppPromo
                    ? "/promotion/".replace("/promotion", "/app-promotion")
                    : "/promotion/"
                }
              >
                Promotions{" "}
              </a>{" "}
              / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>PERA O BAYONG</h1>
                <h2>Mystery Friday</h2>
                <div className="promotion-tnc-period">
                  <strong>Promo Period: </strong>
                  <span>Weekly Promotion</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <strong>Mechanics: </strong>
                <ol>
                  <li>
                    <p>
                      Players who generate a minimum turnover of 100 per
                      provider across at least three (3) different game
                      providers between Monday, 12:00PM and Friday, 11:00AM will
                      be eligible for this promotion.
                    </p>
                  </li>
                  <li>
                    <p>
                      Players will be able to open a mystery PERA o BAYONG
                      option and select one.
                    </p>
                  </li>
                  <li>
                    <p>
                      The PERA contains random free credits with 1x rollover
                      policy before cashout, whereas the BAYONG contains weekly
                      random e-gifts and prizes.
                    </p>
                  </li>
                  <li>
                    <p>
                      Every Friday at 1PM, any qualified player may open their
                      PERA or BAYONG prizes.
                    </p>
                  </li>
                  <li>
                    <p>
                      Prizes MUST be redeemed by the next Friday (11:59AM),
                      otherwise it will be considered forfeited.
                    </p>
                  </li>
                  <li>
                    <p>
                      FGH reserves the right to change, suspend or cancel the
                      promotion at any time.
                    </p>
                  </li>
                </ol>
                {!isAppPromo && (
                  <>
                    <div className="promotion-tnc-cta">
                      {isLoggedIn ? (
                        showMysteryFridayBtn ? (
                          <button
                            onClick={() => setActiveModal(data.title)}
                            className="promotion-cta-btn"
                          >
                            Claim Your Prize
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="promotion-cta-btn"
                            style={{ cursor: "pointer" }}
                            onClick={() => setIsDepositOpen(true)}
                          >
                            Deposit Now
                          </button>
                        )
                      ) : (
                        <LoginGlobal
                          label="Claim Your Prize"
                          btnClass="promotion-cta-btn"
                          onlyBtn={true}
                        />
                      )}
                    </div>
                    {isDepositOpen &&
                      createPortal(
                        <div className="modal-portal">
                          <Deposit
                            onClose={() => setIsDepositOpen(false)}
                            defaultBonusName="New Member Package Bonus"
                          />
                        </div>,
                        document.body
                      )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
